'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./label.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Label(_ref) {
  var className = _ref.className,
      children = _ref.children,
      type = _ref.type,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'type', 'size']);

  var classes = (0, _classnames2.default)('label', 'label--type-' + type, 'label--size-' + size, className);

  return _react2.default.createElement(
    'span',
    _extends({ className: classes }, props),
    children
  );
}

Label.propTypes = {
  children: _propTypes2.default.string,
  className: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['default', 'instruction', 'light', 'active', 'inactive', 'warning', 'default-outlined', 'instruction-outlined', 'light-outlined', 'active-outlined', 'inactive-outlined', 'warning-outlined', 'default-link', 'instruction-link', 'light-link', 'active-link', 'inactive-link', 'warning-link', 'info', 'info-outlined', 'info-link']),
  size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};

Label.defaultProps = {
  type: 'default',
  size: 'small'
};

exports.default = Label;